<template>
    <div class="col-md-12  m-t-20">
        <div class="card">
            <div class="card-header m-t-10">
                <div class="row">
                    <div class="d-md-flex align-items-center col-md-6">
                        <div>
                            <h4 class="m-b-0 card-title">Invoice Summary</h4>
                            <h5 class="card-subtitle">Comprehensive summary details of invoice</h5>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="row">
                            <div class="col-md-6">
                                <v-md-date-range-picker
                                        :auto-apply="false"
                                        :opens="opens"
                                        :show-activator-bar="false"
                                        :show-activator-label="false"
                                        :show-custom-range-label="value"
                                        @change="change"
                                        show-year-select>
                                </v-md-date-range-picker>
                            </div>
                            <div class="col-md-2">
                                <button @click="getInvSummaryInDateRange(1)" class="btn btn-light btn-outline-success" style="height: 42px;" type="button">Go!</button>
                            </div>
                            <div class="col-md-2 btn-arrange">
                                <button @click="reset()" class="btn btn-light btn-outline-secondary" style="height: 42px;" type="button">Reset!</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row m-t-30">
                    <div class="col-lg-6 col-md-12 col-sm-12 m-b-30">
                        <div class="row">
                            <div class="col-4 border-right">
                                <i class="fa fa-circle text-cyan"></i>
                                <h3 class="m-b-0 font-medium">{{draftCount}}</h3>
                                <span>Draft</span>
                            </div>
                            <div class="col-4 border-right">
                                <i class="fa fa-circle text-brown"></i>
                                <h3 class="m-b-0 font-medium">{{voidCount}}</h3>
                                <span>Void</span>
                            </div>
                            <div class="col-4 border-right">
                                <i class="fa fa-circle text-primary"></i>
                                <h3 class="m-b-0 font-medium">{{sentCount}}</h3>
                                <span>Sent</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-12 col-sm-12 m-b-30">
                        <div class="row">
                            <div class="col-4 border-right">
                                <i class="fa fa-circle text-warning"></i>
                                <h3 class="m-b-0 font-medium">{{writeOffCount}}</h3>
                                <span>Write-Off</span>
                            </div>
                            <div class="col-4 border-right">
                                <i class="fa fa-circle text-light-green"></i>
                                <h3 class="m-b-0 font-medium">{{recordPayCount}}</h3>
                                <span>Record Payment</span>
                            </div>
                            <div class="col-4 border-right">
                                <i class="fa fa-circle text-dark-green"></i>
                                <h3 class="m-b-0 font-medium">{{paidCount}}</h3>
                                <span>Paid</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card card-body printableArea m-t-10" v-if="invoice.length > 0">
                <div class="row">
                    <div class="col-md-12">
                        <div class="table-responsive " style="clear: both;">
                            <table class="table table-hover">
                                <thead>
                                <tr>
                                    <th class="text-left">Status</th>
                                    <th class="text-left">Number</th>
                                    <th class="text-left">Created On</th>
                                    <th class="text-left">Amount</th>
                                    <th class="text-left">Action</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-bind:key="index" v-for="(inv, index) in invoice">
                                    <td class="text-left">
                                        <p v-if="inv.status === 'DRAFT'"><span class="label label-cyan">Draft</span></p>
                                        <p v-if="inv.status === 'VOID'"><span class="label label-brown">Void</span></p>
                                        <p v-if="inv.status === 'SENT'"><span class="label label-primary">Sent</span></p>
                                        <p v-if="inv.status === 'WRITE-OFF'"><span class="label label-warning">Write-Off</span></p>
                                        <p v-if="inv.status === 'RECORD_PAYMENT'"><span class="label label-light-green">Payment Recorded</span></p>
                                        <p v-if="inv.status === 'PAID'"><span class="label label-dark-green">Paid</span></p>
                                    </td>
                                    <td class="text-left">{{inv.id}}</td>
                                    <td class="text-left">{{inv.created_at | date}}</td>
                                    <td class="text-left">{{inv.total | money}}</td>
                                    <td class="text-left">
                                        <a @click="viewInvoice(inv.id)" href="javascript:void(0)">
                                            <h6>View Details</h6>
                                        </a>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <span>Showing {{pageNumber}} of {{pageCount}}</span>
                    </div>
                    <div class="col-6">
                        <paginate
                                :click-handler="pageHandler"
                                :container-class="'pagination float-right'"
                                :margin-pages="2"
                                :next-class="'page-link'"
                                :next-text="'Next'"
                                :page-class="'page-link'"
                                :page-count=pageCount
                                :page-range="3"
                                :prev-class="'page-link'"
                                :prev-text="'Prev'"
                                v-model="pageNumber">
                        </paginate>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import _ from "lodash";
    import Paginate from 'vuejs-paginate';

    export default {
        name: "Invoices",
        props: ["memberid", "events"],
        computed: {
            ...mapGetters(["currentOrg"])
        },
        components: {Paginate},
        data() {
            return {
                invoice: [],
                draftCount: 0,
                voidCount: 0,
                sentCount: 0,
                writeOffCount: 0,
                recordPayCount: 0,
                paidCount: 0,
                pageCount: 1,
                pageNumber: 1,
                total: 0,
                inv_from_date: null,
                inv_to_date: null,
                opens: 'left',
                value: true
            }
        },
        mounted() {
            this.getInvoiceSummary(1);
        },
        methods: {
            change(e) {
                this.inv_from_date = e[0].toDate();
                this.inv_to_date   = e[1].toDate();
            },
            async getInvoiceSummary(page) {
                $(".preloader").fadeIn();
                let result = await this.$http
                .get("/marketplaces/" + this.currentOrg.marketplace_id + "/members/" + this.memberid + "/invoiceSummary", {
                    params: {
                        page: page,
                        perPage: 3
                    }
                });

                $(".preloader").fadeOut();
                this.total   = result.data.total;
                this.invoice = result.data.invoice;
                this.setPageCount();
                let allInvoice = result.data.allInvoice;

                let draftInv        = await _.filter(allInvoice, {"status": "DRAFT"});
                let voidInv         = await _.filter(allInvoice, {"status": "VOID"});
                let sentInv         = await _.filter(allInvoice, {"status": "SENT"});
                let writeOffInv     = await _.filter(allInvoice, {"status": "WRITE-OFF"});
                let recordPayInv    = await _.filter(allInvoice, {"status": "RECORD_PAYMENT"});
                let paidInv         = await _.filter(allInvoice, {"status": "PAID"});
                this.draftCount     = draftInv.length;
                this.voidCount      = voidInv.length;
                this.sentCount      = sentInv.length;
                this.writeOffCount  = writeOffInv.length;
                this.recordPayCount = recordPayInv.length;
                this.paidCount      = paidInv.length;
            },
            async getInvSummaryInDateRange(page) {
                $(".preloader").fadeIn();
                let result = await this.$http
                .get("/marketplaces/" + this.currentOrg.marketplace_id + "/members/" + this.memberid + "/invoiceSummary", {
                    params: {
                        page: page,
                        perPage: 3,
                        fromDate: this.inv_from_date,
                        toDate: this.inv_to_date
                    }
                });

                $(".preloader").fadeOut();
                this.total   = result.data.total;
                this.invoice = result.data.invoice;
                this.setPageCount();
                let allInvoice = result.data.allInvoice;

                let draftInv        = await _.filter(allInvoice, {"status": "DRAFT"});
                let voidInv         = await _.filter(allInvoice, {"status": "VOID"});
                let sentInv         = await _.filter(allInvoice, {"status": "SENT"});
                let writeOffInv     = await _.filter(allInvoice, {"status": "WRITE-OFF"});
                let recordPayInv    = await _.filter(allInvoice, {"status": "RECORD_PAYMENT"});
                let paidInv         = await _.filter(allInvoice, {"status": "PAID"});
                this.draftCount     = draftInv.length;
                this.voidCount      = voidInv.length;
                this.sentCount      = sentInv.length;
                this.writeOffCount  = writeOffInv.length;
                this.recordPayCount = recordPayInv.length;
                this.paidCount      = paidInv.length;
            },
            reset() {
                this.inv_from_date = null;
                this.inv_to_date   = null;
                this.getInvoiceSummary(1);
            },
            pageHandler(pageNum) {
                this.pageNumber = pageNum;
                if(this.inv_from_date === null || this.inv_to_date === null) {
                    this.getInvoiceSummary(pageNum);
                } else {
                    this.getInvSummaryInDateRange(1)
                }
            },
            setPageCount() {
                this.pageCount = this.total <= 3 ? 1 : Math.ceil(this.total / 3);
            },
            viewInvoice(invid) {
                this.$router.push({name: "viewmarketplaceinvoice", params: {invoiceid: invid}});
            }
        }
    }
</script>

<style scoped>
    .btn-arrange {
        margin-left: -38px !important;
    }
</style>
